import React from 'react';
import { Box, Typography, Breadcrumbs, Link } from '@mui/material';
import { useParams, useHistory } from 'react-router-dom';
import { CompanyPromotionForm } from '../../components/CompanyPromotionForm';
import { usePromotionForm } from '../../hooks/usePromotionForm';
import { useFormValidation } from '../../hooks/useFormValidation';
import { CircularProgressCenter } from '../../../../components/CircularProgressCenter';

export const CreateCompanyPromotion = () => {
  const { id } = useParams();
  const history = useHistory();
  const isCopy = history.location.pathname.includes('/copy/');
  
  // Определяем режим работы
  const mode = isCopy ? 'copy' : 'create';
  
  // Используем общий хук для управления формой
  const {
    formData,
    setFormData,
    loading,
    promotionLoading,
    error,
    cities,
    initiators,
    buttons,
    handleSubmit,
    handleCancel,
    handleButtonsUpdate,
    isInitialized
  } = usePromotionForm(mode, id);

  // Хук для валидации
  const { validateFullForm } = useFormValidation();

  // Обработчик отправки формы
  const onSubmit = (data) => {
    return handleSubmit(data, validateFullForm);
  };

  if (promotionLoading || (isCopy && !isInitialized)) {
    return <CircularProgressCenter />;
  }

  return (
    <Box>
      <Breadcrumbs sx={{ mb: '24px' }}>
        <Link href="/company-promotions" underline="hover">
          Акции компании
        </Link>
        <Typography color="text.primary">
          {isCopy ? 'Копировать акцию' : 'Создать акцию'}
        </Typography>
      </Breadcrumbs>

      <Typography mb="24px" variant="h1" sx={{ color: 'black' }} component="h1">
        {isCopy ? 'Копировать акцию' : 'Создать акцию'}
      </Typography>

      <CompanyPromotionForm
        formData={formData}
        setFormData={setFormData}
        onSubmit={onSubmit}
        onCancel={handleCancel}
        loading={loading}
        error={error}
        cities={cities}
        initiators={initiators}
        buttons={buttons}
        onButtonsUpdate={handleButtonsUpdate}
        isEdit={false}
        isCopy={isCopy}
      />
    </Box>
  );
};